import { Box, CircularProgress, Typography } from "@mui/material";
import { useTheme } from "@mui/material";
import KeySegmentsNew from "./KeySegmentsNew";
import { useSelector } from "react-redux";
import VideoCard from "./VideoCard";
import LoaderVideo from "./LoaderVideo";

const ResultsPlaybackComponent = (props) => {
  const theme = useTheme();
  const showStorylinesComponent = useSelector(
    (state) => state.keysegmentsAndStorylines.showStorylinesComponent
  );
  const currentStoryline = useSelector(state => state.keysegmentsAndStorylines.currentStoryline);
  const queryType = useSelector(state => state.queryText.queryType);
  const queryTextRedux = useSelector(state => state.queryText.value);
  const user = sessionStorage.getItem('username')?.split('@')[0];
  const username = user.charAt(0).toUpperCase() + user.slice(1);

  //eslint-disable-next-line
  const currentKeysegment = useSelector(state => state.keysegmentsAndStorylines.currentKeysegment);
  return (
    <Box
      flex={1.8}
      p={2}
      className={
        !showStorylinesComponent && !currentStoryline
          ? "flex-center-center"
          : ""
      }
      sx={{
        background: theme.palette.primary.dark,
        // height: "81vh",
        height: "100%",
        borderRadius: "1rem",
        overflow: "auto",
      }}
    >
      {!showStorylinesComponent ? (
        props.socketError && props?.keySegments?.length === 0 ? (
          <Typography mt={"1rem"} p={"1rem"}>
            {props.socketError}
          </Typography>
        ) : props.isCurationCancelled && !props?.currentKeySegment ? (
          <h5 style={{ textAlign: "center" }}>Query Canceled</h5>
        ) : (
          <KeySegmentsNew socketComplete={props?.socketComplete} />
        )
      ) : currentStoryline ||
        (showStorylinesComponent && props.socketResults?.length > 0) ? (
        <Box>
          {queryType === 'chatQuery' && (
            <Box mb={'0.5rem'}>
              <span style={{ fontWeight: 600, color: '#AC1FFF' }}>
                {username}: {queryTextRedux}
              </span>
            </Box>
          )}
          {<p>{currentStoryline?.text}</p>}
          <VideoCard
            compilation={props.socketResults}
            answerText={props.answerText}
            agentText={props.agentText}
            isQA={props.isQA}
            storyMetadata={props.storyMetadata}
            socketComplete={props.socketComplete}
            open_alt_clips_panel={props.open_alt_clips_panel}
            alt_clips_drawer={props.alt_clips_drawer}
            open_debug_panel={props.open_debug_panel}
            debug_drawer={props.debug_drawer}
            debug_messages={props.debugMessages}
            message={props.progressMessage}
            isCurationCancelled={props.isCurationCancelled}
          />
        </Box>
      ) : props.socketError ? (
        props.socketResults?.length == 0 && (
          <Typography mt={"1rem"} p={"1rem"}>
            {props.socketError}
          </Typography>
        )
      ) : props.isCurationCancelled && !props.socketResults?.length > 0 ? (
        <h5 style={{ textAlign: "center" }}>Query Canceled</h5>
      ) : (
        <div style={{ paddingTop: "1.5rem" }}>
          <LoaderVideo />
        </div>
      )}
    </Box>
  );
};

export default ResultsPlaybackComponent;
